import '@babel/polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify'
import Snotify from 'vue-snotify'
import VeeValidate from 'vee-validate'
import store from './store'
import http from './utils/ajax'
import App from './App'
import router from './router'
import MavDirectives from '@/directives'
import MavValidations from '@/validations'
import MavComponents from '@/components/reusable/global'
import HopScotch from 'hopscotch'
import theme from '@/const/theme'
import '@fortawesome/fontawesome-free/css/all.min.css'

Vue.config.productionTip = false

// To allow use of this.$http
Vue.prototype.$http = http

// For easy of tracking mode
Vue.prototype.$mode = process.env.VUE_APP_MODE
document.title = store.state.app.projectTitle

// Tour Component
HopScotch.configure({
  showPrevButton: true,
  onError: () => {
    Vue.prototype.$snotify.error('There is an error with the current tour. Please inform the System Administrator.')
  }
})
Vue.prototype.$tour = HopScotch

// Components Framework
Vue.use(Vuetify, {
  theme: theme[process.env.VUE_APP_MODE],
  iconfont: 'mdi'
})

// Validation Component (and init commonly used validation)
const validateConfig = {
  events: 'blur'
}
Vue.use(VeeValidate, validateConfig)

// Toast Component (vuetify toast are not good enough)
// https://artemsky.github.io/vue-snotify/documentation/api/options.html#snotifyconfig
Vue.use(Snotify, {
  toast: {
    timeout: 3000,
    position: 'rightTop',
    newOnTop: false,
    closeOnClick: true
  }
})

// Maverick Plugins
Vue.use(MavDirectives)
Vue.use(MavValidations)
Vue.use(MavComponents)

// Preload the app (base init)
store.dispatch('preLoadApp')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
